import { useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import gibletLogo from '@/assets/giblet-logo.png';

export default function DemoCallForKnowledgeForm() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-background flex flex-col items-center justify-center p-6">
      <div className="max-w-2xl w-full space-y-8">
        <div className="flex justify-center mb-8">
          <img src={gibletLogo} alt="Giblet Logo" className="h-16 w-auto" />
        </div>

        <div className="text-center space-y-4">
          <h1 className="text-4xl font-bold text-foreground">Call for Knowledge (CfK)</h1>
          <p className="text-xl text-muted-foreground">
            Gather expertise and build validated knowledge bases from domain experts
          </p>
        </div>

        <div className="bg-card rounded-lg p-8 shadow-lg space-y-6">
          <div className="space-y-4">
            <h2 className="text-2xl font-semibold text-foreground">Purpose</h2>
            <p className="text-muted-foreground leading-relaxed">
              A Call for Knowledge (CfK) is used to capture institutional knowledge, document proven methodologies,
              and build comprehensive knowledge bases from domain experts. CfKs fill critical knowledge gaps by
              systematically gathering expertise that can be validated, structured, and made available to AI agents
              for grounding and reasoning.
            </p>
          </div>

          <div className="space-y-4">
            <h2 className="text-2xl font-semibold text-foreground">CfK Workflow Steps</h2>
            <ol className="list-decimal list-inside space-y-3 text-muted-foreground">
              <li>Select the functional area / domain for the knowledge contribution</li>
              <li>Determine if this CfK supports an existing Call for Solution (CfS)</li>
              <li>Configure the Knowledge Bounty and team distribution</li>
              <li>Define the knowledge gap, scope, and acceptance criteria</li>
              <li>Assign team roles: Creator, Contributor, and Confirmer (Giblet)</li>
              <li>Review all details and submit the Call for Knowledge</li>
            </ol>
          </div>

          <div className="bg-primary/10 rounded-lg p-4 space-y-2">
            <h3 className="font-semibold text-foreground">Key Benefits:</h3>
            <ul className="space-y-1 text-muted-foreground text-sm">
              <li>• Capture institutional knowledge before it's lost</li>
              <li>• Build comprehensive, peer-validated knowledge bases</li>
              <li>• Document proven methodologies and best practices</li>
              <li>• Ground AI agents with authoritative, domain-specific data</li>
              <li>• Create reusable IP assets with proper attribution and licensing</li>
              <li>• Connect knowledge contributions to active Solution development</li>
            </ul>
          </div>
        </div>

        <div className="flex justify-center gap-4">
          <Button
            variant="outline"
            onClick={() => navigate('/curt-channel')}
            className="min-w-[120px]"
          >
            Back
          </Button>
          <Button
            onClick={() => navigate('/demo-call-for-knowledge/functional-area')}
            className="min-w-[120px]"
          >
            Next
          </Button>
        </div>
      </div>
    </div>
  );
}
